const defaultHeight = 75;

export const getTeamScheduleListItemHeight = (
  freq: "DAILY" | "WEEKLY" | "MONTHLY",
  footer: boolean
) => {
  const footerHeight = footer ? 40 : 0;
  switch (freq) {
    case "DAILY":
      return defaultHeight + footerHeight;
    case "WEEKLY":
      return defaultHeight + 10 + footerHeight;
    case "MONTHLY":
      return defaultHeight + 10 + footerHeight;
  }
};
